import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AuthorizeThird from '../authorizeThird/AuthorizeThird';
import ChangeDispatchAddress from '../changeDispatchAddress/ChangeDispatchAddress';
import BadState from '../badState/BadState';
import AnotherProduct from '../anotherProduct/AnotherProduct';
import { useHistory } from 'react-router-dom';
import useSetMessage from '../../../../../../../helpers/tickets/SelfServiceHook';
import GoldSilverPaymentForm from '../goldSilverPayment/GoldSilverPaymentForm';
import NotWorking from '../notWorking/NotWorking';
import ArrivedIncomplete from '../arrivedIncomplete/ArrivedIncomplete';
import AssembleProduct from '../assembleProduct/AssembleProduct';
import CancelPurchase from '../cancelPurchase/CancelPurchase';
import CancellationStatus from '../cancellationStatus/CancellationStatus';
import ChangeProduct from '../changeProduct/ChangeProduct';
import AlarmInProduct from '../alarmInProduct/AlarmInProduct';
import NotReceived from '../notReceived/NotReceived';

const FormList = ({ ...props }) => {
  const { motiveId, type, mobile, product } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState({});

  const profile = useSelector((state) => state.profileReducer.profile);
  const {
    selfServiceStatus,
    ticketNoProductStatus: ticketStatus,
    validationStatus,
    validation,
  } = useSelector((state) => state.ticketReducer);

  const dataToShow = (innerData) => {
    setData(innerData);
  };

  useEffect(() => {
    useSetMessage(selfServiceStatus, data, dispatch, history);
  }, [selfServiceStatus, data]);

  useEffect(() => {
    useSetMessage(ticketStatus, data, dispatch, history);
  }, [ticketStatus, data]);

  return (
    <React.Fragment>
      {motiveId === '2' && (
        <NotReceived
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '28' && (
        <AuthorizeThird
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
          selfServiceStatus={selfServiceStatus}
        />
      )}
      {motiveId === '10' && (
        <ChangeDispatchAddress
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          selfServiceStatus={selfServiceStatus}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
        />
      )}
      {motiveId === '29' && (
        <GoldSilverPaymentForm
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '6' && (
        <BadState
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '4' && (
        <ArrivedIncomplete
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '3' && (
        <AnotherProduct
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '5' && (
        <NotWorking
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '35' && (
        <ChangeProduct
          mobile={mobile}
          motiveId={motiveId}
          type={10}
          product={product}
          profile={profile}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
        />
      )}
      {motiveId === '9' && (
        <AssembleProduct
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '7' && (
        <CancelPurchase
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '37' && (
        <AlarmInProduct
          mobile={mobile}
          motiveId={motiveId}
          type={type}
          product={product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {motiveId === '11' && <CancellationStatus mobile={mobile} />}
    </React.Fragment>
  );
};

FormList.propTypes = {
  motiveId: PropTypes.string,
  type: PropTypes.string,
  mobile: PropTypes.bool,
  product: PropTypes.object,
  profile: PropTypes.object,
  selfServiceStatus: PropTypes.string,
  validationStatus: PropTypes.string,
  validation: PropTypes.string,
};

export default FormList;
